module.exports = __webpack_public_path__ + "static/media/agenda.e31194ad.svg";